export const RoleConvertor: { [key: string]: string } = {
    mgr: 'مدیر',
    bnk: 'بانی',
    nrm: '',
    own: 'ایجاد کننده',
}
